import assert from '@banking/ui/utils/assert';
export function decrementNavigation(navigation) {
  const {
    flow,
    current
  } = navigation;
  const currentIndex = flow.indexOf(current);
  assert(currentIndex > 0, 'At start of flow. Cannot decrement current screen');
  return {
    ...navigation,
    current: flow[currentIndex - 1]
  };
}
export function incrementNavigation(navigation) {
  const {
    flow,
    current
  } = navigation;
  const currentIndex = flow.indexOf(current);
  assert(currentIndex >= 0, 'Current index is not part of navigation flow');
  assert(currentIndex + 1 < flow.length, 'At end of flow. Cannot increment current screen');
  return {
    ...navigation,
    current: flow[currentIndex + 1]
  };
}

/**
 * Inserts a new screen into the navigation flow immediately after the current screen.
 * Returns a new navigation object where the new screen is the current screen.
 */
export function getNavigationWithInjectedScreen(navigation, newScreen, followingScreens) {
  const {
    current,
    flow
  } = navigation;
  const currentScreenIndex = flow.indexOf(current);
  const newFlow = [...flow.slice(0, currentScreenIndex + 1), newScreen, ...(followingScreens || flow.slice(currentScreenIndex + 1))];
  return {
    flow: newFlow,
    current: newScreen
  };
}